import React from 'react';
import PhoneList from '../components/routing/PhoneList';

const RoutingPhonePage = () => {
    return (
        <PhoneList />
    )
}

export default RoutingPhonePage;
